export var PAGE_QUERY_PARAM_KEY = "page";
export var PAGE_CHANGE_QUERY_PARAM_KEY = "pc";
export var FILTERS_QUERY_PARAM_KEY = "filters";
export var FILTER_CHANGE_QUERY_PARAM_KEY = "fc";
